export const costs = [
  'Prepari ogni lezione sulle risorse minerali da zero, cercando materiale sparso su internet',
  'Spiegare giacimenti, estrazione e trattamento senza immagini chiare è difficile',
  'Non hai attività, casi di studio e verifiche pronte da usare in classe',
  'Ti manca tempo per programmare unità didattiche complete e coerenti',
];
